export default Object.freeze({
	ParcelGuard: 'parcel_guard',
	Carrier: 'carrier',
	Stamps: 'stamps_com', // Products wants to retire this option soon
});
